export default __webpack_public_path__ + "static/media/quizzesSvg.3a1c665c.svg";